import React, { useState, useRef, useEffect } from "react";
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import CheckButton from "react-validation/build/button";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import Helper from "../../../../Helper";
import AssetesQuote from "./assetsquote";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import { getTrans as t } from "../../../../Localization/translations";
import Quoteservice from "../../../../services/contract/Quotes/quotesServices";
import PaymentDetailsEditQuote from "./paymentdetailsquoteedit";
import { useNavigate } from "react-router-dom";

function QuoteEdit({ id, contractid, setshowhidedit,contract_type }) {
  const navigate = useNavigate();
  const [hasProcessingErrors, setHasProcessingErrors] = useState(false);
  const form = useRef();
  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [transaction_type, setTransaction_Type] = useState("");
  const [transactiondate, setTransaction_Date] = useState(null);
  const [loading, setLoading] = useState(false)
  const [quotedata, setQuoteData] = useState([]);

  const getQuote = () => {
    Quoteservice.getquote(id).then((response) => {
      setQuoteData(response.data.response);
      setTransaction_Type(response.data.response.termination_type)
      setTransaction_Date(response.data.response.termination_date)

    })
  };

  const handleRegister = () => {
    form.current.validateAll()
    setHasProcessingErrors(false); // Reset error state on new attempt

    if (checkBtn.current.context._errors.length === 0) {
    }
    Quoteservice.editquote(
      id,
      contractid,
      transaction_type,
      Helper.DatePicker(transactiondate),
    ).then(
      (response) => {
        if (response.data.success == 1) {
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          setTimeout(() => {
            setshowhidedit(false)
          }, 2000)
        }
        else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
        }
      }
    ).catch((error) => {
      // Intercept Data Quality 400 BAD REQUEST
      if (error.response && error.response.status === 400) {
        setHasProcessingErrors(true); // Show the Review Errors link
        toast.error(error.response.data.error || "Data Quality Check Failed.", {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
        });
      } else {
        toast.error("Failed to update quote");
      }
    });
  }

  useEffect(() => {

    getQuote();

  }, []);
  const handleCancel = () => {
    setshowhidedit(false)
  }

  return (
    <>

      <>
        <div className="header mb-2 pt-3">
          <h5 className="modal-title text-left">{t("Edit Payoff Quote")}</h5>
        </div>
        <div className="card" role="document">
          <div className="card-body">
            <Form ref={form} onSubmit={handleSubmit(handleRegister)} method="POST">
              {
                <div className="row">
                  <div className="form-group row">

                    <div className="col-md-6">
                      <label className="col-lg-12 col-form-label">
                        {t("Payoff Type")}{" "}
                        <Tooltip content={t("PayoffType_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="col-lg-12">
                        <select
                          type="text"
                          value={transaction_type}
                          className="form-control"
                          name='payofftype'
                          {...register('payofftype', { onChange: (e) => { setTransaction_Type(e.target.value) } })}
                        >
                          <option value="">select Transaction Type</option>
                          {contract_type !== 'Rental' ? 
                          <option value="Purchase">Purchase</option> :''
                          }
                          <option value="Return">Return</option>
                        </select>
                        <div className="invalid-feedback">
                          {errors.payofftype?.type === 'required' && "Payoff Type  is required"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="col-lg-12 col-form-label">
                        {t("Termination Date")}{" "}
                        <Tooltip content={t("TerminationDate_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="col-lg-12">
                        <input type="text" value={transactiondate
                          ? Helper.DateNormal(transactiondate)
                          : ""} disabled className="form-control">

                        </input>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <label className="col-lg-12 col-form-label">
                {t("Please Choose Termination Date")}{" "}
              </label>
              <div className="mt-3">
                <PaymentDetailsEditQuote id={contractid} terminationdate={transactiondate} transactiondate={setTransaction_Date} />
              </div>
              <div className="mt-3 mb-3">
                <AssetesQuote id={contractid} />
              </div>
              <div className="text-left py-3 d-flex align-items-center">
                <input type="hidden" id="assetId" />
                <button type="button" className="asset-cancel btn btn-secondary btn-md" onClick={handleCancel}>{t("Cancel")}</button>&nbsp;&nbsp;
                <button type="submit" className="btn-assets border-0 btn btn-primary btn-gradient-primary btn-md">
                  {
                    loading === false ? (
                      t('Save')
                    ) : (
                      <ButtonLoading />
                    )
                  }
                </button>

                {hasProcessingErrors && (
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#dc3545",
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontWeight: "500",
                      marginLeft: "15px"
                    }}
                    onClick={() => navigate("/processing-failure-log", { state: { contract_id: contractid } })}
                  >
                    {t("Review Errors")}
                  </span>
                )}
              </div>
              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Form>
          </div>
        </div>

      </>

    </>
  );
}

export default QuoteEdit;
